import React from "react";
import "~/less/web-internal.less";
import { User } from "~/common/Store/models/User";
import { useInternalNotes } from "./hooks/useInternalNotes";
import { withUserAndChat } from "~/common/Store/connectUserAndChat";

interface InternalNotesButtonProps {
  categoryId: number;
  showInternalNotesModal: boolean;
  toggleInternalNotesModal: () => void;
  user: User;
}

export const defaultInternalNotesData = {
  categoryId: 0,
  link: "",
};

const InternalNotesButtonV2 = ({
  categoryId,
  showInternalNotesModal,
  toggleInternalNotesModal,
  user,
}: InternalNotesButtonProps) => {
  const isInternal =
    user.analyticsData?.is_on_vpn?.toLocaleUpperCase() === "YES";

  const internalNotesData = useInternalNotes(categoryId, isInternal);

  const buttonStyling = showInternalNotesModal
    ? "text-white bg-green-500 border border-solid border-green-600"
    : "text-gray-800 bg-white border border-solid border-gray-300";

  return internalNotesData.categoryId && internalNotesData.link ? (
    <button
      onClick={toggleInternalNotesModal}
      rel="noopener noreferrer"
      id="web-internal-trigger"
      className={`${buttonStyling} fixed bottom-2.5 right-2.5 z-1000 max-w-[142px] group flex items-center px-[7px] py-[7px] font-semibold rounded cursor-pointer`}
      data-testid="show-internal-notes-button"
      data-track="internal-notes-click"
      data-track-ei="internal-notes-leaf-category"
    >
      <i
        className={`${showInternalNotesModal ? "text-white" : "text-red-500"} icon-attention mr-[7px] text-base w-6 h-6`}
      />
      <span className="webinfo-trigger__text text-base text-left leading-none">
        {" "}
        Category Internal Notes
      </span>
    </button>
  ) : null;
};

export default withUserAndChat(InternalNotesButtonV2);
